<template>
  <div>
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('admin.equipment.add.back') }}</span>
    </div>
    <h4>{{ id ? $t('admin.equipment.add.edit') : $t('admin.equipment.add.create') }}</h4>
    <a-form :form="form" layout="vertical">
      <div class="title">{{ $t('admin.equipment.add.basicInfo') }}</div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.equipment.add.name.label')" :colon="false">
          <a-input
            allowClear
            maxLength="30"
            :placeholder="$t('admin.equipment.add.name.placeholder')"
            v-decorator="['name', { rules: [{ required: true, message: $t('admin.equipment.add.name.required') }] }]" ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.equipment.add.number.label')" :colon="false">
          <a-input
            allowClear
            oninput="value=value.replace(/[^\d]/g,'')"
            v-decorator="['number', { rules: [{ required: true, message: $t('admin.equipment.add.number.required') }] }]"
            maxLength="10"
            :placeholder="$t('admin.equipment.add.number.placeholder')"
          ></a-input>
        </a-form-item>
      </div>
      <div class='list'>
        <a-form-item class="full" :label="$t('admin.equipment.add.trainingRoom.label')" :colon="false">
          <a-select
            allowClear
            v-decorator="['trainingRoomId', { rules: [{ required: true, message: $t('admin.equipment.add.trainingRoom.required') }] }]"
            show-search
            :filter-option="filterOption"
            @focus="handleFocus"
            @blur="handleBlur"
            @change="handleChange"
            :placeholder="$t('admin.equipment.add.trainingRoom.placeholder')">
            <a-select-option v-for='item in roomList' :key='item.id' :value="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.equipment.add.status.label')" :colon="false">
          <a-select
            allowClear
            v-decorator="['status', { rules: [{ required: true, message: $t('admin.equipment.add.status.required') }] }]"
            :placeholder="$t('admin.equipment.add.status.placeholder')">
            <a-select-option value="1">{{ $t('admin.equipment.statusOpen') }}</a-select-option>
            <a-select-option value="2">{{ $t('admin.equipment.statusClose') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.equipment.add.brand.label')" :colon="false">
          <a-input
            allowClear
            maxLength="30"
            :placeholder="$t('admin.equipment.add.brand.placeholder')"
            v-decorator="['brand', { rules: [{ required: true, message: $t('admin.equipment.add.brand.required') }] }]"
          ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.equipment.add.model.label')" :colon="false">
          <a-input
            allowClear
            maxLength="30"
            :placeholder="$t('admin.equipment.add.model.placeholder')"
            v-decorator="['model', { rules: [{ required: true, message: $t('admin.equipment.add.model.required') }] }]"
          ></a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.equipment.add.mac.label')" :colon="false">
          <a-input
            allowClear
            maxLength="30"
            :placeholder="$t('admin.equipment.add.mac.placeholder')"
            v-decorator="[
              'mac',
              {
                rules: [
                  {
                    pattern: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
                    message: $t('admin.equipment.add.mac.format')
                  }
                ]
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.equipment.add.isAvailable.label')" :colon="false">
          <a-select
            allowClear
            v-decorator="['isAvailable', { rules: [{ required: true, message: $t('admin.equipment.add.isAvailable.required') }] }]"
            :placeholder="$t('admin.equipment.add.isAvailable.placeholder')"
          >
            <a-select-option value="1">{{ $t('admin.equipment.add.isAvailable.yes') }}</a-select-option>
            <a-select-option value="2">{{ $t('admin.equipment.add.isAvailable.no') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.equipment.add.photo.label')" :colon="false">
          <div style="width: 300px; height: 160px;">
            <Upload
              @uploadData="photosUploadOk"
              :fileUrl="form.getFieldValue('photo')"
              :accept="['png', 'jpg']"
              :desc="['', $t('admin.equipment.add.photo.format')]"
              v-decorator="['photo', {}]"
            />
          </div>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.equipment.add.remark.label')" :colon="false">
          <a-textarea allowClear maxLength="200" :placeholder="$t('admin.equipment.add.remark.placeholder')" v-decorator="['remark']"></a-textarea>
        </a-form-item>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.equipment.add.submit') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import Upload from '@/components/upload/index.vue'
import { getTrainingEquipmentDetail, postTrainingEquipmentSave, getTrainingRoomUsableList } from '@/api/admin'

export default {
  components: {
    Upload
  },
  data() {
    return {
      id: undefined,
      form: this.$form.createForm(this),
      roomList: [],
      uploadUrl: 'your_upload_url' // 请替换为实际的上传地址
    }
  },
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`)
    },
    handleBlur() {
      console.log('blur')
    },
    handleFocus() {
      console.log('focus')
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    back() {
      // this.$router.push({
      //   name: 'teacherList'
      // })
      this.$router.go(-1)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values)
          if(this.id) {
            values.id = this.id
          }
          postTrainingEquipmentSave(values).then(res => {
            if (res.code == 200) {
              const tip = this.id ? this.$t('admin.equipment.add.success.edit') : this.$t('admin.equipment.add.success.create')
              this.$message.success(tip)
              this.$router.go(-1)
            }
          })
        }
      })
    },
    getTrainingEquipmentDetailHttp() {
      getTrainingEquipmentDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          console.log(res.data)
          if (res.data.trainingRoomId == 0) {
            this.form.setFieldsValue({
              name: res.data.name,
              number: res.data.number,
              status: res.data.status.toString()
            })
          } else {
            this.form.setFieldsValue({
              name: res.data.name,
              number: res.data.number,
              trainingRoomId: res.data.trainingRoomId.toString(),
              status: res.data.status.toString(),
              brand: res.data.brand,
              model: res.data.model,
              mac: res.data.mac,
              isAvailable: res.data.isAvailable.toString(),
              photo: res.data.photo,
              remark: res.data.remark
            })
          }
        }
      })
    },
    getTrainingRoomUsableListHttp() {
      getTrainingRoomUsableList({}).then(res => {
        if (res.code == 200) {
          for (let item of res.data.list) {
            this.roomList.push({
              name: item.name,
              id: item.id
            })
          }
        }
      })
    },
    photosUploadOk(data) {
      this.form.setFieldsValue({
        photo: data[0] ? data[0].url : ''
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.getTrainingRoomUsableListHttp()
    if (this.id) {
      this.getTrainingEquipmentDetailHttp()
    }
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-top: 16px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }
  .list {
    display: flex;
    //padding-right: 200px;
    .ant-form-item-label label {
      color: #000000;
    }
    .ant-form-item {
      width: 50%;
      padding-left: 45px;
      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;
      img {
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input {
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .ant-input,
    .ant-select {
      //border-radius: 20px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      //border-radius: 20px;
    }
    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button {
    margin-top: 50px;
    width: 100%;
    // padding-left: 500px;
    text-align: center;
  }
}
/deep/ .ant-form .list .ant-form-item-label label {
  font-weight: 600;
}
</style>
